/** Destroy Chart.js instances bound to admin dashboard canvases. */
export const destroyAdminCharts = () => {
  const ChartLib = window.Chart;
  if (!ChartLib || typeof ChartLib.getChart !== 'function') return;

  document.querySelectorAll('canvas').forEach((canvas) => {
    const chart = ChartLib.getChart(canvas);
    if (chart) chart.destroy();
  });
};

export const removeDashboardScript = () => {
  const script = document.querySelector('script[data-dashboard="true"]');
  if (script) script.remove();
};

export const loadDashboardScript = () => {
  const src = '/admin-assets/js/dashboard.js';
  removeDashboardScript();
  destroyAdminCharts();

  const script = document.createElement('script');
  script.src = src;
  script.setAttribute('data-dashboard', 'true');
  document.body.appendChild(script);
};
